import { UserSubmission } from "./UserSubmission";
import { Form } from "models/forms/Form";
// Fallback definition to avoid module resolution issues
export interface UserSubmissionDto {
    workflowId: string;
    nodeId: string;
    projectId: string;
    type: string;
}

export class FormSubmission extends UserSubmission {
    formId: string = "";
    form: Form | null = null;
    type: string = "FormSubmission";
};

export interface FormSubmissionDto extends UserSubmissionDto {
    formId: string;
    formSubmission: FormSubmission;
}